import { Resource, ResourceState } from 'v2/store/common/Resource';

export function isIdleState(state: ResourceState): boolean {
  return state === ResourceState.Idle;
}

export function isLoadingState(state: ResourceState): boolean {
  return state === ResourceState.Loading;
}

export function isSuccessState(state: ResourceState): boolean {
  return state === ResourceState.Success;
}

export function isFailureState(state: ResourceState): boolean {
  return state === ResourceState.Failure;
}

export function isIdleResource<T>(resource: Resource<T>): boolean {
  return isIdleState(resource.state);
}

export function isLoadingResource<T>(resource: Resource<T>): boolean {
  return isLoadingState(resource.state);
}

export function isSuccessResource<T>(resource: Resource<T>): boolean {
  return isSuccessState(resource.state);
}

export function isFailureResource<T>(resource: Resource<T>): boolean {
  return isFailureState(resource.state);
}

export function isEmptyResource<T>(resource: Resource<T>): boolean {
  if (!isSuccessState(resource.state)) {
    return false;
  }

  if (Array.isArray(resource.data)) {
    return resource.data.length === 0;
  }

  return !resource.data;
}

export function hasAnyLoadingResource(resources: Resource<any>[]): boolean {
  return resources.some(isLoadingResource);
}

export function hasAnyIdleLoadingResource(resources: Resource<any>[]): boolean {
  return resources.some(isIdleResource);
}

export function hasAnyFailureResource(resources: Resource<any>[]): boolean {
  return resources.some(isFailureResource);
}

export function hasAnyEmptyResource(resources: Resource<any>[]): boolean {
  return resources.some(isEmptyResource);
}
